import { useMutation } from "@tanstack/react-query";
import { client } from "./api-client";

export const useAuthVerifyEmployee = () =>
  useMutation({
    mutationFn: (employeeId) => client(`auth/verify/employee/${employeeId}`),
  });

export const useGetAssignee = () =>
  useMutation({
    mutationFn: (data) =>
      client(
        `auth/users/groups/${data.region}${data.assignment ? `/${data.assignment}` : ""}`
      ),
  });
export const useGetEmployees = () =>
  useMutation({
    mutationFn: (designation) => client(`auth/users/list/${designation}`),
  });

export const useGetEmployeeDetails = () =>
  useMutation({
    mutationFn: (employeeId) =>
      client(`auth/employee/details/${employeeId}`, { hideError: true }),
  });

export const useGetUserProfile = () =>
  useMutation({
    mutationFn: () => client(`auth/user/profile`),
  });
export const useUpdateProfile = () =>
  useMutation({
    mutationFn: (data) =>
      client("auth/update/profile", {
        method: "put",
        data,
        successMessage: "Profile updated successfully",
      }),
  });

export const useChangePassword = () =>
  useMutation({
    mutationFn: (data) =>
      client("auth/change/password", {
        data,
        successMessage: "Password updated successfully",
      }),
  });
export const useGetFieldTeam = () =>
  useMutation({
    mutationFn: () => client("auth/field/team"),
  });
export const useGetUserByRoles = () =>
  useMutation({
    mutationFn: (data) => client("auth/users/in/roles", { data }),
  });
